
import { Vue, Component, Watch } from "vue-property-decorator";
import ApplyForm from "@/components/ApplyForm.vue";
import PictureSlide from "@/components/PictureSlide.vue";
import FaqSection from "@/components/FaqSection.vue";
import { formatUpyunUrl } from "@/utils";
// import {openJesongChat} from "easy"
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { generateMetaInfo, getServiceJsonLd } from "@/utils/seo";

@Component({
  components: {
    ApplyForm,
    PictureSlide,
    Breadcrumb,
    FaqSection
  }
})
export default class weixue extends Vue {
  // FAQ 数据
  faqList = [
    { question: "微学是什么平台？", answer: "光华微学是企业培训数字化管理平台，涵盖学、考、练、用全流程，提供学习运营与管理、海量课程库、数据化反馈、内部知识沉淀。" },
    { question: "微学有哪些核心功能？", answer: "核心功能包括海量课程库、内部知识沉淀、学习运营与管理、培训数字化管理、数据化反馈，帮助企业实现培训全流程数字化。" },
    { question: "微学适合什么企业？", answer: "适合希望实现培训数字化转型、提升培训效率与效果的各类企业，尤其适合需要系统化管理员工学习与发展的中大型企业。" }
  ];
  get metaInfo() {
    return generateMetaInfo({
      title: "微学 | 学·考·练·用，企业培训数字化管理平台 - 光华赋能",
      description:
        "光华微学是企业培训数字化管理平台，涵盖学、考、练、用全流程，提供学习运营与管理、海量课程库、数据化反馈、内部知识沉淀，帮助企业实现培训数字化转型。",
      keywords:
        "微学,企业培训平台,培训数字化,学习管理系统,LMS,在线培训,企业学习,知识沉淀,光华赋能",
      path: "/weixue",
      breadcrumb: [
        { name: "首页", url: "/" },
        { name: "数字化" },
        { name: "微学" }
      ],
      jsonLd: getServiceJsonLd({
        name: "微学",
        description:
          "企业培训数字化管理平台，涵盖学、考、练、用全流程，提供学习运营、课程库、数据反馈、知识沉淀等功能。",
        category: "企业培训管理平台"
      })
    });
  }

  formatUpyunUrl = formatUpyunUrl;
  pic1 = "/img/46ca14bd2d83fcb93ee5433e47408105.png";
  pic2 = "/img/7a0f2b1d6b8a7e54251abde21128ed39.png";
  pic3 = "/img/a9967ea3fb6bda69c9b11ee2a1fa436e.png";
  pic4 = "/img/894ed857c406df3d3d994a927527431a.png";
  pic5 = "/img/df6fa5d2f7a00205282823aca3910f28.png";

  List = [
    { title: "数字化", url: "" },
    { title: "微学", url: "" }
  ];

  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "数字化方案陪跑，EPM企业绩效系统，绩效飞轮，ELP，微学，光华商学"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "专家，落地指导，规划，战略到执行，数字化转型方案，数字化，转型，数字化+，+数字化，数字化管理体系，业务转型，效率提升，持续增长，底层框架 ,全盘规划,从战略到执行全流程,过程,落地,问题,目标,调研,诊断,成果,复盘,赛道分析,企业位置,行业趋势,企业现状营收、盈利、规模、定位、生态位、战略控制点、价值主张,组织与人才,人才、组织盘点,结构、员工数,管理体系机制、制度、流程（尤其是业务主流程）、股权,差距分析,机会差距,业绩差距,三找,找差距、找不满、,找原因,梳理核心问题,对标对标杆,对历史数据,对BLM,目标共识,FCIL四个角度,企业培训,海量课程库，阶段目录，有序学习，要点检测，成果考核，加深理解，记忆实践，巧用关联，灵活使用，学，考，练，用，个人学习，缺乏体系，员工提升，管理层、电商、营销等不同团队缺乏专属课程资源，无法进行精准的专项培训，人才培养效率低下，因学习资源与培训体系不完善，导致关键岗位的能力成长缓慢，业务发展受到制约，人才培养的滞后，最终成为企业创新与增长步伐的瓶颈，实力名师，体系化学习，结构化知识体系，精品课，试听"
    );
    document.head.appendChild(metaTag2);
  }
  beforeDestroy() {
    // 移除之前添加的meta标签，防止内存泄漏
    const metas1 = document.head.querySelectorAll('meta[name="keywords"]');
    metas1.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
    const metas2 = document.head.querySelectorAll('meta[name="description"]');
    metas2.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
  }
}
